import { enqueueSnackbar } from 'notistack';
import { CraftFeedback } from 'Types/craft';

import { API_URL, enrichedFetch } from './api';

export const sendFeedback = async (feedback: CraftFeedback): Promise<boolean> => {
  try {
    const response = await enrichedFetch(`${API_URL}/craft/feedback`, {
      method: 'POST',
      body: JSON.stringify(feedback),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return response as boolean;
  } catch {
    enqueueSnackbar('Failed to send feedback', { variant: 'error' });
    throw new Error('Failed to send feedback');
  }
};
